<template>
  <!-- Section du catalogue du matériel, déroulée par défaut (sauf « replie ») et enroulable (29/10/2026) ; sous-titre pour l'administrateur, rien au survol. -->
  <section class="section-catalogue" :data-section="titre">
    <h2>
      <button type="button" class="section-bouton" :aria-expanded="ouvert ? 'true' : 'false'" @click="ouvert = !ouvert">
        <span class="chevron">{{ ouvert ? '▾' : '▸' }}</span>{{ titre }}
      </button>
      <span v-if="aVerifier" class="nb-verifier">{{ aVerifier }} à vérifier</span>
      <slot name="entete" />
    </h2>
    <div v-show="ouvert" class="section-contenu">
      <p v-if="sousTitre" class="sous-titre">{{ sousTitre }}</p>
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionCatalogue',
  props: {
    titre: { type: String, required: true },
    sousTitre: { type: String, default: '' },
    // nombre de valeurs à vérifier dans la section
    aVerifier: { type: Number, default: 0 },
    // enroulée à l'ouverture de la page (ex. règles batterie ↔ onduleur, 02/11/2026)
    replie: { type: Boolean, default: false },
  },
  data() {
    return { ouvert: !this.replie }
  },
}
</script>

<style scoped>
.section-catalogue { margin-bottom: 10px; border-bottom: 1px solid #eef0f3; padding-bottom: 6px; }
h2 { display: flex; align-items: center; margin: 0; font-size: 17px; font-weight: 700; color: #1a1a2e; text-align: left; }
.section-bouton { border: none; background: none; padding: 6px 0; font: inherit; color: inherit; cursor: pointer; text-align: left; }
.chevron { display: inline-block; width: 18px; color: #888; }
.section-contenu { padding: 6px 0 10px 18px; }
.nb-verifier { margin-left: 10px; padding: 1px 8px; border-radius: 10px; background: #fff6bf; border: 1px solid #d9a400; color: #6b5300; font-size: 12px; font-weight: 600; }
.sous-titre { margin: 0 0 8px; font-size: 12px; color: #555; text-align: left; }
.section-contenu ::v-deep h3 { font-size: 14px; font-weight: 700; color: #3a3f4b; margin: 12px 0 4px; text-align: left; }
</style>
